import { FC, useState, Fragment } from "react";
import Header from "./Header";
import { Layout } from "antd";
import MenuComponent from "../components/MenuComponent/Menu";
import { SiderTriggerSvg } from "../assets/customIcons";
import { SimpleModal } from "../ui-kit";
import { ToastContainer } from "../components/ToastContainer/ToastContainer";
import classNames from "classnames";
import { configAxios } from "../api/Api";
import menuStore from "../store/menu";
import { observer } from "mobx-react-lite";
import simpleModalStore from "../store/simpleModalStore";
import styles from "./styles/Layout.module.scss";

configAxios();

const { Content, Sider } = Layout;

const LayoutMain: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { menuIsCollapsed } = menuStore;
  const [paddingTop, setPaddingTop] = useState("55px");

  const getHeight = (height: number) => {
    // + top and bottom of padding
    setPaddingTop(`${height+16}px`);
  };

  return (
    <Fragment>
      <ToastContainer />
      <Header getHeight={getHeight} collapsed={menuIsCollapsed.value} />
      <Layout>
        <Sider
          collapsible
          collapsed={menuIsCollapsed.value}
          onCollapse={(collapsed) => menuIsCollapsed.toggle()}
          width={300}
          className={classNames(styles.Aside, {
            [styles.AsideCollapsed]: menuIsCollapsed.value,
          })}
          trigger={SiderTriggerSvg}
        >
          <MenuComponent />
        </Sider>

        <Content
          className={classNames(
            styles.Content,
            styles.ContentWithPad,
            !menuIsCollapsed.value && styles.ContentCollapsed,
          )}
          style={{ paddingTop }}
        >
          <SimpleModal
            isActive={simpleModalStore.open}
            onClose={() => simpleModalStore.closeModal()}
            width={simpleModalStore.width}
            height={simpleModalStore.height}
          >
            {simpleModalStore.content}
          </SimpleModal>
          {children}
        </Content>
      </Layout>
    </Fragment>
  );
};

export default observer(LayoutMain);
